import PropTypes from "prop-types"

import Breadcrumb from "./breadcrumb"

const NoInfoLayout = ({ children, heading, title }) => (
  <>
    <div className="contained px-16">
      <Breadcrumb title={heading || title} />
    </div>
    {children}
  </>
)

NoInfoLayout.propTypes = {
  children: PropTypes.element.isRequired,
  description: PropTypes.string,
  heading: PropTypes.string,
  layout: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default NoInfoLayout
